import React, { Component } from "react";
import { Grid, Paper } from "@material-ui/core";
import TopMembersTable from "./Tables/TopMembers";
import LatestShootTable from "./Tables/LatestShoot";

class DashboardDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sample: false
    };
  }

  render() {
    return (
      <div>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={3}>
            <Paper style={{ backgroundColor: "#F39C12", padding: "10px" }}>
              <h1
                style={{
                  fontSize: 80,
                  margin: 0,
                  color: "white",
                  opacity: 0.5
                }}
              >
                10
              </h1>
              <h2
                style={{
                  margin: 0,
                  textAlign: "right",
                  position: "relative",
                  color: "white"
                }}
              >
                Shoots Made
              </h2>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper style={{ backgroundColor: "#C0392B", padding: "10px" }}>
              <h1
                style={{
                  fontSize: 80,
                  margin: 0,
                  color: "white",
                  opacity: 0.5
                }}
              >
                1
              </h1>
              <h2
                style={{
                  margin: 0,
                  textAlign: "right",
                  position: "relative",
                  color: "white"
                }}
              >
                Admin
              </h2>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper style={{ backgroundColor: "#43A047", padding: "10px" }}>
              <h1
                style={{
                  fontSize: 80,
                  margin: 0,
                  color: "white",
                  opacity: 0.5
                }}
              >
                5
              </h1>
              <h2
                style={{
                  margin: 0,
                  textAlign: "right",
                  position: "relative",
                  color: "white"
                }}
              >
                Members
              </h2>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper style={{ backgroundColor: "#3498DB", padding: "10px" }}>
              <h1
                style={{
                  fontSize: 80,
                  margin: 0,
                  color: "white",
                  opacity: 0.5
                }}
              >
                89.9%
              </h1>
              <h2
                style={{
                  margin: 0,
                  textAlign: "right",
                  position: "relative",
                  color: "white"
                }}
              >
                Shot Approved
              </h2>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper>
              <h3 style={{ margin: "10px", color: "#898989" }}>
                Top 5 members
              </h3>
              <TopMembersTable />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper>
              <h3 style={{ margin: "10px", color: "#898989" }}>Latest Shoot</h3>
              <LatestShootTable />
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default DashboardDetails;
